import { IconCheck, IconX } from '@tabler/icons-react';

import type { StyledIcon } from '#plugin-chat/lib/tool/message-formatters.ts';

/**
 * Visual intent for an interactive button: confirm (positive), cancel
 * (neutral/back-out), or danger (destructive). Single source of truth
 * for the union — adding an intent here is a compile error at every
 * consuming site until the {@link INTENT_TOKENS} table is filled in.
 */
export type Intent = keyof typeof INTENT_TOKENS;

export type IntentToken = {
  /** Mantine `Button` `color` prop. */
  color: string;
  /** Mantine `Button` `variant` prop. */
  variant: 'filled' | 'subtle';
  /** Leading-section icon for slides that show one. */
  icon: StyledIcon;
};

/**
 * Coordinated color + variant + icon palette for action buttons. Both
 * {@link InteractionCard}'s `Action` and {@link ConfirmationSlide} look
 * up styling here so confirm/cancel/danger buttons stay visually
 * consistent across the tool-display chrome.
 */
export const INTENT_TOKENS = {
  confirm: { color: 'green', variant: 'filled', icon: IconCheck },
  cancel: { color: 'gray', variant: 'subtle', icon: IconX },
  danger: { color: 'red', variant: 'filled', icon: IconX },
} as const satisfies Record<string, IntentToken>;
